import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction } from '@ztechapps/common.contract'
import type { ScanDetail } from '../entities/ScanDetail'

/**
 * The action's contract, and deliberately only that: two identifiers and the acting user. The
 * query's `filter`/`options` are GraphQL transport — `ScanDetailResolver` unpacks them and they
 * stop there, so this action never learns those two words exist.
 */
@InputType()
export class GetScanDetailArgs extends ActionArgs {
  /** The teacher the scan is resolved against — every record read is scoped to this owner. */
  @Field(() => ID)
  ownerId: string

  /**
   * The AI usage row to open, and the only handle the caller passes. Both the reference to the
   * scan and the feature key that says what it points at are read off this row server-side, so
   * resolving a scan never depends on the caller holding the row.
   */
  @Field(() => ID)
  transactionId: string
}

/**
 * `null` means one thing only: no usage row for that owner. Every other miss — no reference, an
 * unrecognised feature key, a reference pointing at a deleted record — comes back as a populated
 * `ScanDetail` of kind `NoScanLinked`, never null and never a throw.
 */
export interface IGetScanDetail extends IAction<ScanDetail | null, GetScanDetailArgs> {}
